import { render, staticRenderFns } from "./ShowEnquiryRawData.vue?vue&type=template&id=206154fd&"
import script from "./ShowEnquiryRawData.vue?vue&type=script&lang=js&"
export * from "./ShowEnquiryRawData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports